(function () {
  const POPUP_ID = 'twExtraDiscountPopup';
  const STORAGE_KEY = 'tw_extra_discount_popup_last';

  const SHOW_EVERY_HOURS = 24; // max 1 volta ogni 24 ore
  const DELAY_MS = 6000;       // dopo 6 secondi
  const ONLY_ON = 'all';       // 'all' | 'product' | 'collection' | 'cart'

  function onCorrectPage() {
    const path = location.pathname || '';
    if (ONLY_ON === 'all') return true;
    if (ONLY_ON === 'product') return path.startsWith('/products/');
    if (ONLY_ON === 'collection') return path.startsWith('/collections/');
    if (ONLY_ON === 'cart') return path.startsWith('/cart');
    return true;
  }

  function shouldShow() {
    const last = Number(localStorage.getItem(STORAGE_KEY) || 0);
    const hours = (Date.now() - last) / 36e5;
    return hours >= SHOW_EVERY_HOURS;
  }

  function openPopup() {
    const el = document.getElementById(POPUP_ID);
    if (!el) return;
    el.style.display = 'flex';
    el.setAttribute('aria-hidden', 'false');
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  function closePopup() {
    const el = document.getElementById(POPUP_ID);
    if (!el) return;
    el.style.display = 'none';
    el.setAttribute('aria-hidden', 'true');
  }

  function bindClose() {
    const el = document.getElementById(POPUP_ID);
    if (!el) return;

    // click overlay
    el.addEventListener('click', (e) => {
      if (e.target === el) closePopup();
    });

    // bottoni close
    el.querySelectorAll('[data-tw-close]').forEach(btn => {
      btn.addEventListener('click', closePopup);
    });

    // ESC
    document.addEventListener('keydown', (e) => {
      const visible = el.style.display === 'flex';
      if (visible && e.key === 'Escape') closePopup();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!onCorrectPage()) return;
    bindClose();
    if (!shouldShow()) return;
    setTimeout(openPopup, DELAY_MS);
  });
})();
